import React, { memo, forwardRef } from 'react';
import {
  BenefitImage,
  BenefitContent,
  BenefitHeader,
  Wrapper,
  StyledText,
} from './components';
import { purify } from '../../lib/purify';
import { textClass } from '@spotify-internal/encore-web/core';
import { BaseImageType } from './image';

export type BenefitSize = 'small' | 'medium' | 'skyscraper';
type BenefitPropTypes = {
  content: string;
  header?: string;
  size?: BenefitSize;
  imageSources?: BaseImageType['sources'];
};

const Benefit = forwardRef<HTMLLIElement, BenefitPropTypes>(function Benefit(
  { header, imageSources: imageSourcesProp, content, size = 'medium' },
  ref,
) {
  return (
    <Wrapper ref={ref} size={size}>
      {imageSourcesProp && (
        <BenefitImage sources={imageSourcesProp} size={size} />
      )}
      <BenefitContent>
        {header && (
          <BenefitHeader
            className={textClass('titleLarge')}
            as="p"
            dangerouslySetInnerHTML={{
              __html: purify(header),
            }}
          />
        )}
        {content && (
          <StyledText dangerouslySetInnerHTML={{ __html: purify(content) }} />
        )}
      </BenefitContent>
    </Wrapper>
  );
});

export default memo(Benefit);
